export const TABS = {
  SUMMARY: 'SUMMARY',
  DIAGNOSIS: 'DIAGNOSIS',
  ENCOUNTERS: 'ENCOUNTERS',
}

export const formatDiseases = (diseases, lang) => {
  if (!diseases || !diseases?.length) return []
  const out = []
  diseases.forEach(d => {
    // Prefer the dashboard language, but fall back to any available translation
    // so a code is never displayed without a name.
    const names = d.name || {}
    const name = names[lang] ?? Object.values(names)[0]
    out.push({
      id: d.id,
      code: d.code,
      name,
    })
  })
  return out
}
